module.exports = __webpack_public_path__ + "img/dsci0030.61ece11a.jpg";